// components/DynamicTileLayer.js
import { TileLayer } from "react-leaflet";
import React from "react";

const basemapURLs = {
    White: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  Dark: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  Satellite: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  Streets: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
};

const attributions = {
    White: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  Dark: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  Satellite: '&copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics',
  Streets: '&copy; OpenStreetMap contributors',
};

const DynamicTileLayer = ({ basemap }) => {
  const url = basemapURLs[basemap] || basemapURLs["White"];
  const attribution = attributions[basemap] || attributions["White"];

  return <TileLayer key={basemap} url={url} attribution={attribution} />;

};

export default DynamicTileLayer;
